import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import './index.css';
import App from './App';
import ReactDOM from 'react-dom';

import reportWebVitals from './reportWebVitals';
import { analytics, logEvent } from './firebase/firebase';
import { AlertProvider } from './Provider/Common/AlertProvider';
import { ConsentProvider } from './consent/ConsentProvider';

(ReactDOM as any).findDOMNode = function(inst: any) {
  return inst && inst.input ? inst.input : null;
};

// Create root using the new client API
const root = ReactDOMClient.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ConsentProvider>
      <AlertProvider>
        <App />
      </AlertProvider>
    </ConsentProvider>
  </React.StrictMode>
);

// Capture unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const message = event?.reason?.message || String(event?.reason || '');
  const stack = event?.reason?.stack || '';
  try {
    if (analytics) {
      logEvent(analytics, 'frontend_error', {
        message,
        stack,
        type: 'unhandledrejection',
      });
    }
  } catch (err) {
    // ignore analytics errors
  }

  if (message.includes('Loading chunk')) {
    try {
      if (analytics) {
        logEvent(analytics, 'chunk_load_error', { message, stack });
      }
    } catch (err) {
      // ignore analytics errors
    }
  }
});

// Capture generic runtime errors
window.addEventListener('error', (event) => {
  const message = event?.message || '';
  const stack = event?.error?.stack || '';
  try {
    if (analytics) {
      logEvent(analytics, 'frontend_error', {
        message,
        stack,
        type: 'error',
      });
    }
  } catch (err) {
    // ignore analytics errors
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
